module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section genghuanbeijing",
    staticStyle: {
      "background": "url('../static/assets/images/fengdian.jpg')no-repeat center",
      "background-size": "100% 100%"
    }
  }, [_c('div', {
    staticClass: "container diannao_fangan",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "line-height": "30px",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "35%",
      "position": "absolute",
      "padding": "30px 80px",
      "font-size": "14px",
      "float": "left",
      "background": "rgba(255, 255, 255, 0.76)",
      "border-radius": "10px",
      "left": "20px",
      "bottom": "2%"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fanganinfo.def1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "padding-bottom": "50px",
      "font-size": "14px",
      "position": "absolute",
      "top": "80px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "45%",
      "position": "absolute",
      "right": "-11%",
      "top": "-65px",
      "background": "rgba(255, 255, 255, 0.76)",
      "padding": "30px 80px",
      "border-radius": "10px"
    }
  }, [_vm._v(_vm._s(_vm.fanganinfo.def2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container shouji_fangan",
    staticStyle: {
      "display": "none",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "line-height": "30px",
      "font-weight": "bold",
      "background": "#ffffff2e",
      "padding": "10px",
      "color": "#ffffff",
      "border-radius": "10px",
      "top": "9%",
      "width": "95%",
      "height": "80%",
      "position": "absolute"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-bottom": "0px",
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fanganinfo.def1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding-bottom": "0px",
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fanganinfo.def2) + "\n        ")])])])]), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding section sj_qhone"
  }, [_c('div', {
    staticClass: "shojikak sj_qiehuan"
  }, [_c('div', {
    staticClass: "chanpin_s2 diannao_fangan1",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, _vm._l((_vm.fanganlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_02 animate zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "1s"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/jiejueinfo?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a",
      staticStyle: {
        "border-radius": "0px",
        "border": "0px"
      }
    }, [_c('div', {
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center;width: 100%;height: 200px;')
    }), _vm._v(" "), _c('div', {
      staticClass: "tiaozhuan001",
      staticStyle: {
        "height": "130px",
        "width": "100%",
        "background": "#ffffff",
        "padding": "7px"
      }
    }, [_c('h4', {
      staticClass: "xinwen"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#666666"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontent(item.description)) + "...")]), _vm._v(" "), _vm._m(1, true)])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s2 shouji_fangan1"
  }, _vm._l((_vm.fanganlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_02 animate zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "1s"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/jiejueinfo?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a",
      staticStyle: {
        "border-radius": "0px",
        "border": "0px"
      }
    }, [_c('div', {
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center;width: 100%;height: 80px;')
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "70px",
        "width": "100%",
        "background": "#ffffff",
        "padding": "7px"
      }
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#666666"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontentb(item.description)) + "...")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between shouji_fangan1",
    staticStyle: {
      "width": "90%",
      "margin-left": "5%"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex",
    staticStyle: {
      "width": "40%",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzus(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换上一组")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex",
    staticStyle: {
      "width": "40%",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzux(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换下一组")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between diannao_fangan1",
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex qiehuan_shang"
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzus(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换上一组")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex qiehuan_xia"
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzux(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换下一组")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "40px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding fangan_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "color": "#E91E63",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("\n        SOLUTION")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiaozhuan002"
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "border": "1px solid #cccccc",
      "padding": "5px 20px",
      "border-radius": "20px"
    }
  }, [_vm._v("Details\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c408f43e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Fangan.vue
// module id = 118
// module chunks = 0